import { getPost } from './post-selectors';
import { getPaginationConfig } from '../constants/comments-pagination-config';

const getPagination = (state, postId, commentsOrdering) => {
  const postData = getPost(state, postId);

  return (
    state.commentsPagination[postId] || {
      commentsPaginationConfig: getPaginationConfig(postData, commentsOrdering),
      pagerState: { type: 'NONE' },
    }
  );
};

export const getCommentsPaginationConfig = (state, postId, commentsOrdering) =>
  getPagination(state, postId, commentsOrdering)?.commentsPaginationConfig || {};

export const getPagerStateItems = (state, postId) =>
  getPagination(state, postId)?.pagerState?.items || [];
